import ProductContainer from "../ProductContainer";
import { useParams } from "react-router-dom";
import "./index.css";
import RawMaterialComponents from "./ProdRawMaterials";
import rawMaterialSeparator from "../../../assets/new-product-detail-cats/separator/raw-material-separator.svg";
import prodManufacturingSeparator from "../../../assets/new-product-detail-cats/separator/prod-manufacturing-separator.svg";
import ProdManufacturingComponents from "./ProdManufacturing";
import ProdEnergyComponents from "./ProdEnergy";
import prodEnergySeparator from "../../../assets/new-product-detail-cats/separator/prod-energy-separator.svg";
import ProdSurplusResources from "./ProdSurplusResource";
import prodSurplusSeparator from "../../../assets/new-product-detail-cats/separator/surplus-resource-separator.svg";
import ProdDeliveriesComponent from "./ProdTransport";
import prodDeliveriesSeparator from "../../../assets/new-product-detail-cats/separator/prod-deliveries-separator.svg";
import ProdTravelComponents from "./ProdTravel";
import prodTravelSeparator from "../../../assets/new-product-detail-cats/separator/prod-travel-separator.svg";
import prodProcessingSeparator from "../../../assets/new-product-detail-cats/separator/prod-processing-separator.svg";
import ProcessingIntermediateComponent from "./ProdProcessing";
import UseOfSoldComponent from "./ProdUseOfSold";
import prodFinalTreatmentSeparator from "../../../assets/new-product-detail-cats/separator/prod-final-treatment-separator.svg";
import FinalTreatmentComponent from "./ProdFinalTreatment";

export const ProductDetailView = ({ showCategory, setShowCategory }) => {
  const { productId } = useParams();

  return (
    <ProductContainer>
      <div className="raw-material-relative">
        <RawMaterialComponents
          productId={productId}
          showCategory={showCategory}
          setShowCategory={setShowCategory}
        />
        <img
          src={rawMaterialSeparator}
          alt="Raw Material Separator"
          className="raw-material-separator"
        />
      </div>
      <div className="prod-manufacturing-relative">
        <ProdManufacturingComponents productId={productId} />
        {/* <img
          src={prodManufacturingSeparator}
          alt="Manufacturing Separator"
          className="prod-manufacturing-separator"
        /> */}
        <img
          src={prodSurplusSeparator}
          alt="Surplus Separator"
          className="prod-surplus-separator"
        />
      </div>
      {/* <div className="prod-energy-relative">
        <ProdEnergyComponents productId={productId} />
        <img
          src={prodEnergySeparator}
          alt="Energy Separator"
          className="prod-energy-separator"
        />
      </div>
      <div className="prod-surplus-relative">
        <ProdSurplusResources productId={productId} />
        <img
          src={prodSurplusSeparator}
          alt="Surplus Separator"
          className="prod-surplus-separator"
        />
      </div> */}
      <div className="prod-deliveries-relative">
        <ProdDeliveriesComponent productId={productId} />
        <img
          src={prodDeliveriesSeparator}
          alt="Deliveries Separator"
          className="prod-deliveries-separator"
        />
      </div>
      <div className="prod-travel-relative">
        <ProdTravelComponents productId={productId} />
        <img
          src={prodTravelSeparator}
          alt="Travel Separator"
          className="prod-travel-separator"
        />
      </div>
      <div className="prod-processing-relative">
        <ProcessingIntermediateComponent productId={productId} />
        <img
          src={prodProcessingSeparator}
          alt="Processing Separator"
          className="prod-processing-separator"
        />
      </div>
      <div className="prod-use-sold-relative">
        <UseOfSoldComponent productId={productId} />
        <img
          src={prodSurplusSeparator}
          alt="Use of Sold Separator"
          className="prod-use-sold-separator"
        />
      </div>
      <div className="prod-final-treatment-relative">
        <FinalTreatmentComponent productId={productId} />
        <img
          src={prodFinalTreatmentSeparator}
          alt="Final Treatment Separator"
          className="prod-final-treatment-separator"
        />
      </div>
    </ProductContainer>
  );
};
